import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import AppHeaderBar from "../AppHeaderBar";
import AppNavBar from "../AppNavBar";

const InstallationSubpageLayout = ({
  pageTitle,
  onBack,
  setCookies,
  saveUser,
  headerAction,
  headerTitle,
  shellClassName,
  actionDock,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <div className="installation-detail-page installation-subpage">
      <AppHeaderBar
        title={headerTitle ?? t("Installation")}
        setCookies={setCookies}
        saveUser={saveUser}
      />
      <div
        className={
          shellClassName
            ? `installation-detail-shell installation-subpage-shell ${shellClassName}`
            : "installation-detail-shell installation-subpage-shell"
        }
      >
        <header className="installation-subpage-nav">
          <button
            type="button"
            className="installation-subpage-back"
            onClick={onBack}
            aria-label={t("installation_rotation_back")}
          >
            <FaArrowLeft aria-hidden />
          </button>
          <h1 className="installation-subpage-title">{pageTitle}</h1>
          {headerAction && (
            <div className="installation-subpage-nav-action">
              {headerAction}
            </div>
          )}
        </header>
        {children}
      </div>
      {actionDock}
      <AppNavBar />
    </div>
  );
};

export default InstallationSubpageLayout;
